module.exports = __webpack_public_path__ + "img/24_48.d454c5a5.png";